import axios from './../../function/axiosInstance'
import extract from './../../function/extract'

interface Extra {
  reference_files: string[]
  design_layout_sizes?: string
  design_frames_needed: unknown
  design_sizes: string[]
  design_number_of_pages: number
}

interface billingItem {
  discount: number
  discount_percent: number
  final_amount: number
  tax_amount: number
  taxes: []
  total: number
  sub_total: number
}

interface Include {
  id: string
  name: string
  word_count?: number
  vertical: number
  genre: number
  experience_level: number
  translation_language_target?: number
  category: number
  extra?: Extra
  billing_item?: billingItem
}

interface Item {
  type: 'ContentProject'
  includes: Include[]
}

interface Payload {
  company_id: string
  items: Item[]
}

interface ReturnDataType {
  first_delivery_estimate: number
  project_delivery_estimate: number
  checkout_session_url?: string
  available_promo_codes: {
    total: number
    data: {
      discount: {
        amountLimit: number
        type: 'percent'
        percentOff: number
        amountOff: number
      }
      voucher: {
        code: string
        title: string
        category: string
        type: 'DISCOUNT_VOUCHER'
        metadata: Record<string, unknown>
      }
    }[]
  }
  sub_total: PayScale
  discount: {
    amount: number
    currency: number
    promo_code: string
    promo_code_discount_amount: number
    promo_code_discount_percentage: number
    promo_code_title: string
  }
  total_tax: PayScale
  payable_amount: PayScale
  includes: Include[]
  vendor_order_id: string
  order_id: string
}

interface ReturnType {
  status: 'ok' | 'error'
  data: ReturnDataType | null
  error?: string
}

const getQuotation = async (payload: Payload): Promise<ReturnType> => {
  try {
    const response = await axios.post(`/estimates/v2`, payload)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export default getQuotation
